import { Check, X } from "lucide-react";
import Reveal from "@/components/landing/Reveal";

const pillars = [
  {
    number: "01",
    title: "Architecture orientée conversion (CRO)",
    desc: "La majorité des agences livrent une vitrine passive. Nous concevons chaque section, titre et bouton pour maximiser les appels, les prises de rendez-vous et les demandes de devis.",
  },
  {
    number: "02",
    title: "Vitesse de chargement éclair",
    desc: "Moins de 1,5 seconde de chargement. Zéro perte de trafic sur mobile et un meilleur classement SEO local, jour après jour.",
  },
  {
    number: "03",
    title: "Zéro risque pour votre trésorerie",
    desc: "Aucun acompte massif de 4 000 $ à 8 000 $. Vous protégez votre cash-flow avec un montant prévisible aux 2 semaines, rentabilisé dès vos premières ventes.",
  },
];

const rows = [
  {
    feature: "Investissement initial",
    agence: "3 000 $ à 8 000 $ d'avance",
    diy: "0 $, mais 50h de votre temps perdues",
    notre: "0 $ d'avance — abonnement souple",
  },
  {
    feature: "Design & stratégie",
    agence: "Vitrine passive, souvent surfacturée",
    diy: "Design amateur, template vu partout",
    notre: "Sur-mesure pensé pour convertir",
  },
  {
    feature: "Hébergement & maintenance",
    agence: "Facturé à l'heure pour chaque bug",
    diy: "Vous gérez les bugs seul",
    notre: "100% inclus et géré pour vous",
  },
  {
    feature: "Après la livraison",
    agence: "Intérêt limité une fois payé",
    diy: "Aucun accompagnement",
    notre: "Intérêts 100% alignés sur votre succès",
  },
];

export default function Comparison() {
  return (
    <section id="comparatif" className="relative py-20 lg:py-32" data-testid="comparison-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="font-mono-label mb-4">Chapitre 01 — Pourquoi nous</p>
          <h2 className="max-w-3xl text-2xl font-bold leading-snug tracking-tight text-white sm:text-3xl lg:text-4xl">
            Un site web n'est pas une dépense.{" "}
            <span className="text-emerald-400">
              C'est une machine à générer des clients.
            </span>
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-3 lg:gap-10">
          {pillars.map((p, i) => (
            <Reveal key={p.number} delay={i * 0.12}>
              <article
                className="group glass h-full rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1 hover:border-emerald-400/30 hover:shadow-[0_10px_30px_rgba(16,185,129,0.15)]"
                data-testid={`pillar-card-${p.number}`}
              >
                <span className="text-stroke font-display text-5xl font-extrabold">
                  {p.number}
                </span>
                <h3 className="mt-5 text-xl font-semibold text-white">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-gray-400">{p.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="mt-20">
          <div className="overflow-x-auto" data-testid="comparison-table">
            <div className="min-w-[820px] overflow-hidden rounded-2xl border border-white/8">
              <div className="grid grid-cols-4 bg-[#0F141C]">
                <div className="p-5" />
                <div className="p-5 text-sm font-semibold text-gray-400">Agence classique</div>
                <div className="p-5 text-sm font-semibold text-gray-400">
                  Plateformes DIY (Wix, Shopify)
                </div>
                <div className="relative bg-emerald-500/10 p-5 text-sm font-bold text-emerald-300">
                  Notre service
                  <span className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full border border-emerald-400/30 bg-emerald-500/15 px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-emerald-300">
                    Le choix rationnel
                  </span>
                </div>
              </div>
              {rows.map((row, i) => (
                <div
                  key={row.feature}
                  className={`grid grid-cols-4 ${i % 2 === 0 ? "bg-[#0A0F16]" : "bg-[#0C1219]"}`}
                >
                  <div className="p-5 text-sm font-semibold text-gray-200">{row.feature}</div>
                  <div className="flex items-start gap-2.5 p-5 text-sm text-gray-400">
                    <X className="mt-0.5 h-4 w-4 shrink-0 text-red-400/70" />
                    {row.agence}
                  </div>
                  <div className="flex items-start gap-2.5 p-5 text-sm text-gray-400">
                    <X className="mt-0.5 h-4 w-4 shrink-0 text-red-400/70" />
                    {row.diy}
                  </div>
                  <div className="flex items-start gap-2.5 bg-emerald-500/[0.06] p-5 text-sm font-medium text-emerald-100">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" />
                    {row.notre}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
